import React from 'react';
import { Spin, Space } from 'antd';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import { FormSection, FormLabel, VariableButton } from '../styles';

interface VariablesPanelProps {
  variables: string[];
  loading: boolean;
  onInsertVariable: (variable: string) => void;
}

const VariablesPanel: React.FC<VariablesPanelProps> = ({ variables, loading, onInsertVariable }) => {
  return (
    <FormSection>
      <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.AVAILABLE_VARIABLES}</FormLabel>
      {loading ? (
        <Spin size="small" />
      ) : (
        <Space wrap style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {variables.map((variable, index) => (
            <VariableButton
              key={index}
              size="small"
              type="default"
              onClick={() => onInsertVariable(variable)}
            >
              {variable}
            </VariableButton>
          ))}
        </Space>
      )}
    </FormSection>
  );
};

export default VariablesPanel;
